import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueRouterPrefetch from 'vue-router-prefetch'
import VueNotify from 'vue-notifyjs'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import ElementUI from 'element-ui';
import App from './App.vue'
import store from './store';

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar';
// import CKEditor from '@ckeditor/ckeditor5-vue';
import CKEditor from 'ckeditor4-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import './util/veeValidate.js';
import NProgress from 'nprogress';
import i18n from './i18n'

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard)

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'
import './registerServiceWorker'


import vSelect from 'vue-select';
Vue.component('v-select', vSelect);
import 'vue-select/dist/vue-select.css';

// plugin setup
Vue.use(ElementUI);
Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(CKEditor)
Vue.use(SideBar, { sidebarLinks: sidebarLinks })


locale.use(lang)

// configure router
const router = new VueRouter({
    mode: 'history',
    routes, // short for routes: routes
    linkActiveClass: 'active',
    scrollBehavior: (to) => {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    }
})

// router settings
router.beforeEach((to, from, next) => {
    NProgress.start()
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn'));

    if (requiresAuth && !isLoggedIn) {
        next({ name: 'Login' });
    } else if (to.name == 'Login' && isLoggedIn) {
        next({ name: 'dashboard' });
    } else {
        next();
    }
});


router.afterEach((to, from) => {
    // Complete the animation of the route progress bar.
    NProgress.done()
})

initProgress(router);

/* eslint-disable no-new */
new Vue({
    i18n,
    el: '#app',
    render: h => h(App),
    router,
    store
})
